module.exports = __webpack_public_path__ + "static/media/img_18.5a7a421a.JPG";